import { localStorageService, StorageKeys } from '@ibk/shared-utils';
import { isDevelopment } from '../config';
export const ENABLED_FEATURE_HEADER = 'X-TR-ENABLED-FEATURE';
export const getEnabledFeature = () => {
    if (!isDevelopment()) {
        return null;
    }
    try {
        const value = localStorageService.getItemSync(StorageKeys.EnabledFeature);
        return value ?? null;
    }
    catch {
        return null;
    }
};
export const setEnabledFeature = (value) => {
    if (!isDevelopment()) {
        return;
    }
    localStorageService.setItemSync(StorageKeys.EnabledFeature, value);
};
export const clearEnabledFeature = () => {
    localStorageService.removeItem(StorageKeys.EnabledFeature);
};
